import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useDaily, useLocalSessionId } from '@daily-co/daily-react';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { BGMAtom, BGMVolumeAtom } from '../../State';
import { useTranslation } from 'react-i18next';
import DataModel from '../Util/DataModel';
import { getImagePath } from '../Util/utils';

export default function BGM() {
  //Daily系
  const callObject = useDaily();
  const localSessionId = useLocalSessionId();

  const [BGMState, setBGMState] = useRecoilState(BGMAtom);
  const [volumeState, setVolumeState] = useRecoilState(BGMVolumeAtom);
  const { t } = useTranslation();
  const audioRef = useRef(null);

  // useEffect(() => {
  //   const handleEsc = (e) => {
  //     if (e.shiftKey && e.code == 'KeyM') {
  //       if (audioRef.current == null) {
  //         setBGMState('https://faceless.hiho.jp/background/audio/bgm1.mp3');
  //       } else {
  //         setBGMState(null);
  //       }
  //     }
  //   };
  //   window.addEventListener('keydown', handleEsc);
  // }, []);

  //データベースに保存
  function saveData(status) {
    //データベースに保存
    if (callObject != null) {
      callObject
        .getMeetingSession()
        .then(async (session) => {
          try {
            //自分の情報をseessionに登録
            await DataModel.saveSessionToRoom(
              null, //ルームID
              session.meetingSession.id, //ルームのセッションID
              localSessionId, //ユーザーのテンポラリーユーザーID
              null, //顔
              null, //背景
              null, //顔認識 <isFaceTrackingå>
              null, //録画中
              null, //ミュート
              null, //WhoUse
              null, //ユーザー他タイプ
              BGMState, //BGM
            );

            console.log('セッション保存完了');
          } catch (error) {
            console.log(error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  //セッション情報を元に更新
  useEffect(() => {
    // let url = 'https://faceless.hiho.jp/background/audio/bgm1.mp3';
    // let au = new Audio(url);
    // au.pause();
    // //au.play();

    // return;

    if (BGMState != null) {
      if (audioRef.current != null) {
        //停止
        audioRef.current.pause();
        audioRef.current = null;
      }
      //再生
      let url;
      if (BGMState.startsWith('custom')) {
        url = 'https://storage.googleapis.com/faceless-97bcf.appspot.com/mybgm/' + BGMState;
      } else {
        url = 'https://faceless.hiho.jp/background/audio/' + BGMState;
      }

      audioRef.current = new Audio(url);
      audioRef.current.loop = true;
      audioRef.current.volume = volumeState / 100; //0.15;
      audioRef.current.play();
    } else {
      if (audioRef.current != null) {
        //停止
        audioRef.current.pause();
        audioRef.current = null;
      }
    }
  }, [BGMState, volumeState]);

  //レンダービュー
  return false;
}
